import keyMirror from '../../util/keyMirror';

export default keyMirror('ProductTypes', [
    'LOAD_PRODUCT_TYPES_START',
    'LOAD_PRODUCT_TYPES_SUCCESS',
    'LOAD_PRODUCT_TYPES_FAIL'
]);
